import { Injectable, computed, signal } from "@angular/core";
import { ConfirmModalStateModel } from "./ConfirmModalModel";

@Injectable({ providedIn: "root" })
export class ConfirmModalState {
  private readonly state = signal<ConfirmModalStateModel | null>(null);

  readonly data = computed(() => this.state());

  setModal(modal: ConfirmModalStateModel): void {
    this.state.set(modal);
  }

  setLoading(isLoading: boolean): void {
    this.state.update((current) =>
      (() => {
        if (current) {
          return { ...current, isLoading };
        }
        return current;
      })(),
    );
  }

  clear(): void {
    this.state.set(null);
  }
}
